import React from "react"
import Cabecalho from "../Cabecalho"
import { FormPromocaoFidelidade } from "./components/FormPromocaoFidelidade"

export function CadastroPromocaoFidelidade() {
    return (
        <>
            <Cabecalho pagina="Programa de Fidelidade" />
            <FormPromocaoFidelidade />
        </>
    )
}
